"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoRooms/Room/History/Desktop/SessionDetails.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _helpers = require('web/components/VideoRooms/Room/History/helpers');

var _LoadingSpinner = require('web/components/VideoRooms/Room/History/LoadingSpinner'); var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
var _ParticipantDetails = require('./ParticipantDetails'); var _ParticipantDetails2 = _interopRequireDefault(_ParticipantDetails);








const tableFilters = {
  PARTICIPANT: 'participant',
  TIME: 'time',
  DURATION: 'duration',
  FEEDBACK: 'feedback',
} 



const DesktopSessionDetails = ({
  roomKey,
  roomName,
  currentSessionKey,
  gotoHistory,
}) => {
  const [currentFilter, setCurrentFilter] = _react.useState(null)
  const [session, setSession] = _react.useState(null)

  // componentDidMount: the session is fetched once, for the keys at mount.
  _react.useLayoutEffect.call(void 0, () => {
    // SAFETY: VideoRoomSessionFetch answers with the session; a failed fetch
    // resolves undefined and the spinner stays, as in JS.
    _actions2.default.fetchVideoRoomSession({ RoomKey: roomKey, RoomSessionKey: currentSessionKey })
      .then(fetched => setSession(fetched ))
  // oxlint-disable-next-line react-hooks/exhaustive-deps -- mount only, like componentDidMount
  }, [])

  const toggleFilter = (f) =>
    setCurrentFilter(currentFilter === f ? null : f)

  const renderHistoryBody = () => {
    const buildHeaderColClassName = (filter, className) => _classBuilder2.default.call(void 0, 
      "meeting--table-col",
      className,
      currentFilter === filter && 'active',
    )

    if (!session) return null

    const { startedAt, duration } =
      _helpers.formatTimingLabels.call(void 0, session.StartedAt, session.EndedAt)

    return (
      _react2.default.createElement(_react2.default.Fragment, null
        , _react2.default.createElement('div', { className: "meeting-room--history--summary", __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}
          , _react2.default.createElement('div', { className: "meeting-room--history--summary-row row-title" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}
            , _react2.default.createElement('h4', { className: "meeting-room--history--summary-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}, "Meeting Title" )
            , _react2.default.createElement('span', { className: "meeting-room--history--summary-content", __self: this, __source: {fileName: _jsxFileName, lineNumber: 63}}
              ,  roomName 
            )
          )
          , _react2.default.createElement('div', { className: "meeting-room--history--summary-row row-time" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}
            , _react2.default.createElement('h4', { className: "meeting-room--history--summary-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}}, "Started")
            , _react2.default.createElement('span', { className: "meeting-room--history--summary-content", __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}}, startedAt)
          )
          , _react2.default.createElement('div', { className: "meeting-room--history--summary-row row-duration" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}}
            , _react2.default.createElement('h4', { className: "meeting-room--history--summary-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 72}}, "Total Duration" )
            , _react2.default.createElement('span', { className: "meeting-room--history--summary-content", __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}
              ,  duration 
            )
          )
        )
        , _react2.default.createElement('div', { className: "meeting--table meeting-room--history--details-table" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 78}}
          , _react2.default.createElement('div', { className: "meeting--table-header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}
            , _react2.default.createElement('div', { className: "meeting--table-row", __self: this, __source: {fileName: _jsxFileName, lineNumber: 80}}
              , _react2.default.createElement('div', {
                onClick: () => toggleFilter(tableFilters.PARTICIPANT),
                className: buildHeaderColClassName(tableFilters.PARTICIPANT, "participant-col"), __self: this, __source: {fileName: _jsxFileName, lineNumber: 81}}
, "Participant")
              , _react2.default.createElement('div', {
                onClick: () => toggleFilter(tableFilters.TIME),
                className: buildHeaderColClassName(tableFilters.TIME, "time-col"), __self: this, __source: {fileName: _jsxFileName, lineNumber: 85}}
, "Joined")
              , _react2.default.createElement('div', {
                onClick: () => toggleFilter(tableFilters.DURATION),
                className: buildHeaderColClassName(tableFilters.DURATION, "duration-col"), __self: this, __source: {fileName: _jsxFileName, lineNumber: 89}}
, "Total Time" )
              , _react2.default.createElement('div', {
                onClick: () => toggleFilter(tableFilters.FEEDBACK),
                className: buildHeaderColClassName(tableFilters.FEEDBACK, "feedback-col"), __self: this, __source: {fileName: _jsxFileName, lineNumber: 93}}
, "Call Feedback" )
            )
          )
          , _react2.default.createElement('div', { className: "meeting--table-body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 99}}
            , 
              session.RoomUsers.map((u, i) => {
                const { startedAt, duration } = _helpers.formatTimingLabels.call(void 0, u.InitialJoinedAt, u.LastDisconnectedAt)
                return (
                  _react2.default.createElement(_ParticipantDetails2.default, {
                    key: i,
                    participantName: u.RoomUserName,
                    startedAt: startedAt,
                    duration: duration,
                    rating: u.Rating, __self: this, __source: {fileName: _jsxFileName, lineNumber: 104}}
                  )
                )
              })
            
          )
        )
      )
    )
  }

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('div', { className: "meeting-room--history--header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 122}}
        , _react2.default.createElement('span', {
          onClick: gotoHistory,
          className: "meeting-room--history--header-back", __self: this, __source: {fileName: _jsxFileName, lineNumber: 123}}
, "Back to all"

        )
      )
      ,  session
        ? renderHistoryBody()
        : (
          _react2.default.createElement('div', { className: "meeting-room--history--spinner", __self: this, __source: {fileName: _jsxFileName, lineNumber: 133}}
            , _react2.default.createElement(_LoadingSpinner2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 134}} )
          )
          )
      
    )
  )
}

exports. default = DesktopSessionDetails
